import React, { useState, useEffect } from "react";
import { createPortal } from 'react-dom';
import axios from 'axios';
import stilePulsanti from "../interfaccia/stilePulsanti";
import apiUrl from "../Apiurl";
import { useAuth0 } from '@auth0/auth0-react';
import prodottoVuotoPerDatiUlteriori from "../prodottoVuotoPerDatiUlteriori";
import _ from "lodash";
import InputTendinaCategoria from "../modificaProdotti/elementiPagina/InputTendinaCategoria";
import CategorieWebSub from "../modificaProdotti/moduliArticolo/CategorieWebSub";

function AggiuntaMassivaCategorieDB({ utente, temaColori, mobile }) {

    const [selectedFile, setSelectedFile] = useState();
    const [isFilePicked, setIsFilePicked] = useState(false);
    const [risultatoOperazione, setRisultatoOperazione] = useState("In attesa dell'upload");
    const [risultatoMassiva, setRisultatoMassiva] = useState(false);
    const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState("");
    const [input, setInput] = useState({
        idDatoUlt: "",
        idValoreDatoUlt: "",
        elencoCodiciVS: ""
    });
    const [popUpWindow, setPopUpWindow] = useState(false);
    const [prodottoTemp, setProdottoTemp] = useState(prodottoVuotoPerDatiUlteriori);
    const [tab, setTab] = useState("CatWeb")
    const [datiUlterioriStandard, setDatiUlterioriStandard] = useState({});
    const [datiCategorieWeb, setDatiCategorieWeb] = useState([]);
    const [datiCategoriaPred, setDatiCategoriaPred] = useState(prodottoTemp.categoriaPredefinita ?? "")
    const [salvato, setSalvato] = useState(true);
    const [syncDashboard, setSyncDashboard] = useState(true);

    const {
        inputClasses,
        vociMenuTabs,
        vociMenuTabsSelezionata,
        inputClassesConDueTasti,
        inputClassesNoMeasure
    } = stilePulsanti

    const setFinestra = function (e, finestra) {
        e.preventDefault();
        setPopUpWindow(finestra)
    }
    function chiudi(e) {
        e.preventDefault();
        setPopUpWindow(false);
    }

    useEffect(() => {
        const getUserMetadata = async () => {

            try {
                const accessToken = await getAccessTokenSilently();
                setToken(accessToken);
            } catch (e) {
                console.log(e.message);
            }
        };
        getUserMetadata();
    }, [getAccessTokenSilently, user?.sub]);

    useEffect(() => {
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        fetch(apiUrl + "/prodotti/get/datiUlteriori", { headers: { Authorization: "Bearer " + token } })
            .then(resp => resp.json())
            .then(data => setDatiUlterioriStandard(data))
        //console.log("ad ogni modo i dati ulteriori sono questi: ", datiUlterioriStandard);
    }, [token]);

    const controllaOggettiCategorie = function (valueArr, obj) {
        if (obj.children && obj.children.length > 0) {
            obj.children.forEach((childObj) => controllaOggettiCategorie(valueArr, childObj))
        }
        if (typeof obj.value !== "undefined" && valueArr.includes(obj.value)) {
            obj.checked = true;
        }
    }

    const controllaOggettiCategoriePerCatPredefinita = function (valueArr, obj, newArr) {
        if (obj.children && obj.children.length > 0) {
            obj.children.forEach((childObj) => controllaOggettiCategoriePerCatPredefinita(valueArr, childObj, newArr))
        }
        if ((typeof obj.value !== "undefined" && valueArr.includes(obj.value) || obj.checked)) {
            let nuovoOgg = { value: obj.value, label: obj.label }
            newArr.push(nuovoOgg)
        }
    }

    useEffect(() => {
        if (datiUlterioriStandard.categorieWeb && datiUlterioriStandard.categorieWeb.length > 0) {
            let tempArr = _.cloneDeep(datiUlterioriStandard.categorieWeb)
            tempArr.forEach((oggetto) => controllaOggettiCategorie(prodottoTemp.categorieWebAssociate, oggetto))
            setDatiCategorieWeb(tempArr);
        }
    }, [datiUlterioriStandard]);

    useEffect(() => {
        if ((prodottoTemp.categorieWebAssociate && prodottoTemp.categorieWebAssociate.length > 0) && datiUlterioriStandard.categorieWeb) {
            let newArr = []
            let tempArr = _.cloneDeep(datiUlterioriStandard.categorieWeb)
            tempArr.forEach((ogg) => controllaOggettiCategoriePerCatPredefinita(prodottoTemp.categorieWebAssociate, ogg, newArr));
            setDatiCategoriaPred(["", ...newArr]);
        }
    }, [prodottoTemp.categorieWebAssociate, datiUlterioriStandard.categorieWeb]);


    const handleChangeID = async function (evt) {
        const value = evt.target.value;
        try {

            setInput({
                ...input,
                [evt.target.name]: value
            });

        } catch (err) {
            console.log("Errore nell'aggiornamento di un dato non nestato: " + err)
            throw err;
        }
    }

    const changeHandler = (event) => {
        setSelectedFile(event.target.files[0]);
        setIsFilePicked(true);
    };

    const handleSubmission = async (e) => {
        e.preventDefault();
    
        if (prodottoTemp.categorieWebAssociate.length === 0) {
            delete prodottoTemp.categorieWebAssociate;
        }
    
        const data = {
            prodottoPerDocumento: prodottoTemp,
            elencoCodiciVS: input.elencoCodiciVS.toString().split(","),
            utente: utente,
            dashboard: syncDashboard
        };
    
        try {
            const response = await axios.patch(
                `${apiUrl}/manutenzione/mongodb/aggiuntaMassivaCategorieDB`,
                data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                }
            );
    
            // Gestione della risposta
            console.log("Risposta dal server:", response.data);
            
            setRisultatoMassiva(response.data);

        } catch (error) {
            // Gestione dell'errore
            console.error("Errore nell'invio del prodotto alle API:", error);
            if (error.response) {
                // Errore dalla risposta del server
                console.error("Errore del server:", error.response.data);
            } else if (error.request) {
                // Nessuna risposta ricevuta
                console.error("Nessuna risposta dal server:", error.request);
            } else {
                // Errore nell'impostazione della richiesta
                console.error("Errore nella configurazione della richiesta:", error.message);
            }
        }
    };

    const handleSubmissionCSVtoArr = () => {
        const formData = new FormData();

        formData.append('uploaded_file', selectedFile);


        fetch(
            apiUrl + "/csv/getArray/reference",
            {
                method: 'POST',
                body: formData,
                /* headers: {'Authorization': 'Bearer '+token} */
            }
        ).then(resp => resp.json())
            .then((result) => {
                console.log(result)
                setInput({
                    ...input,
                    elencoCodiciVS: [result]
                })
                setRisultatoOperazione("Dati caricati correttamente")
                console.log('Success:', result);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    };

    function cambiaTab(e) {
        e.preventDefault();
        setTab(e.target.id);
    }

    /* const handleChangeCategorieWeb = async function (currentNode, selectedNodes) {
        setSalvato(false);
        const arr = selectedNodes.map((el) => el.value) // aggiungo le categorie parent in server
        try {
            const update = _.set(_.cloneDeep(prodottoTemp), "categorieWebAssociate", arr)
            setProdottoTemp(update)
        } catch (err) {
            console.log("Errore nell'aggiornamento dell'albero categorie: " + err)
            throw err;
        }
    } */

        const handleChangeCategorieWeb = (currentNode, selectedNodes) => {
                    setSalvato(false);
            
                    try {
                
                        // Aggiorna lo stato del prodotto con le categorie selezionate
                        const updatedProduct = _.set(_.cloneDeep(prodottoTemp), "categorieWebAssociate", selectedNodes);
                        setProdottoTemp(updatedProduct);
                    } catch (err) {
                        console.error("Errore nell'aggiornamento dell'albero categorie:", err);
                        throw err;
                    }
                };
    
    const handleChangeDatoUlteriore = async function (evt) {
        const value = evt.target.value;
        console.log("handleChangeDatoUlteriore value", value)
        console.log("handleChangeDatoUlteriore evt.target.name", evt.target.name)
        try {
            const update = _.set(_.cloneDeep(prodottoTemp), evt.target.name, value) // USO QUESTO METODO INVECE DI QUELLO SOPRA MA E' RESOURCE EXPENSIVE
            console.log("handleChangeDatoUlteriore update", update)
            setProdottoTemp(update)
        } catch (err) {
            console.log("Errore nell'aggiornamento di un dato ulteriore: " + err)
            throw err;
        }
    }

    return (
        <div className="colonnaTuttaPagina flex items-start justify-center ">
            {popUpWindow === "conferma" && <div>
                {createPortal(
                    <div id="modal-root">
                        <div className='modal' onClick={chiudi}>
                        </div>
                    </div>,
                    document.body)}
                {createPortal(
                    <div id="modal-content">
                        <div className={"bg-white " + temaColori + " finestraPopUp colonna85vh sezioneConScroll"}>
                            <div className='pa2'>
                                <button className="dim tastoInputOrizzontale br3" onClick={chiudi}>{stilePulsanti.tastoChiudiAspetto}</button>
                                <div className='mt2 pa4 flex'>
                                    <div>
                                        <p>Saranno aggiunte queste categorie:</p>
                                        <div className="sezioneConScroll"><pre className=''>{JSON.stringify(prodottoTemp, null, 2)}</pre></div>
                                        <p>Su questi codici:</p>
                                        <textarea
                                            value={input.elencoCodiciVS}
                                            name="elencoCodiciVS" onChange={handleChangeID}
                                            id="elencoCodiciVS" className={inputClassesNoMeasure}
                                            type="textarea"
                                            rows="8"
                                            aria-describedby="name-desc"
                                            autoComplete="off" />
                                        <div className="b f4 mt3 pt3 mb3">i dati pre-esistenti saranno sovrascritti!</div>
                                        <div className="tc pt2 flex items-center justify-center">
                                            <div className="flex items-center justify-center pointer ba br3 b--red pa3" onClick={handleSubmission}>
                                                <div><span class="material-symbols-outlined red">warning</span></div>
                                                <div>SONO SICURO</div>
                                            </div>
                                        </div>
                                        {risultatoMassiva && <div className=""><pre className=''>{JSON.stringify(risultatoMassiva, null, 2)}</pre></div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>,
                    document.body
                )}
            </div>}
            <div className="flex justify-center">
                <div className="sfondoColonna bordoAngoloBassoSX pa4 w-40 w-40-l maxAltezza90 shadow-4">
                    <h2>Aggiunta massiva categorie</h2>
                    <label for="elencoCodiciVS">Elenco codici VS</label><br />
                    <textarea
                        value={input.elencoCodiciVS}
                        name="elencoCodiciVS" onChange={handleChangeID}
                        id="elencoCodiciVS" className={inputClassesNoMeasure}
                        type="textarea"
                        rows="8"
                        aria-describedby="name-desc"
                        autoComplete="off" />
                    <h3>Importazione codiciVS tramite csv</h3>

                    <p>Richiede un file csv con una colonna "reference" in un qualsiasi punto,<br />
                        i cambi saranno effettuati sui codici VS contenuti in quella colonna.
                    </p>

                    <input type="file" accept="csv" name="file" onChange={changeHandler}  />
                    {isFilePicked ? (
                        <div>
                            <p>Nome del file: {selectedFile.name}</p>
                            <p>Tipo file: {selectedFile.type}</p>
                            <p>Dimensione in bytes: {selectedFile.size}</p>
                            <p>
                                Data ultima modifica:{' '}
                                {selectedFile.lastModifiedDate.toLocaleDateString()}
                            </p>
                        </div>
                    ) : (
                        <p></p>
                    )}
                    {isFilePicked && <div>
                        <button onClick={handleSubmissionCSVtoArr} className="tastoInputOrizzontaleNoRadNoHeight br3 pa2">Carica</button>
                    </div>}
                    <div>

                    </div>
                    <p>{risultatoOperazione}</p>
                    <div className="pa4 flex flex-wrap justify-center">
                        <button className="tastoInputOrizzontaleNoRadNoHeight br3 pa3 h3" onClick={(e) => { setFinestra(e, "conferma") }}>Applica i dati <br />su tutti i codici</button>
                        <form className="pa3">
                            <input
                            type="checkbox"
                            id="opt-in-checkbox"
                            checked={syncDashboard}
                            onChange={(event) => {
                                setSyncDashboard(event.target.checked);
                            }}
                            />
                            <label htmlFor="opt-in-checkbox" className="pl2">
                            Sincronizza le modifiche online
                            </label>
                        </form>
                    </div>
                </div>
                <div className="lineaSepSinistra bordoAngoloBassoDX colonnaTuttaPagina sfondoColonna pl3 pr2 pb2 w-60 w-60-l shadow-4">
                    <div className=" colonna3-l fl-l w-100 w-50-ns w-30-l pt2 pb2 pl2 colonna90vh-l bt-s bordoColAlt">
                        {/* <h3>Schede</h3>
                        <p id="CatWeb" onClick={cambiaTab} className={tab === "CatWeb" ? vociMenuTabsSelezionata : vociMenuTabs}>Albero categorie web</p> */}
                        <h3>Categorie</h3>
                        <p id="CatWeb" onClick={cambiaTab} className={tab === "CatWeb" ? vociMenuTabsSelezionata : vociMenuTabs}>Albero categorie web</p>
                        
                        {utente.permessiAPI["read:debug"] && <h3>Debug</h3>}
                        {utente.permessiAPI["read:debug"] && <p id="debug" onClick={cambiaTab} className={tab === "debug" ? vociMenuTabsSelezionata : vociMenuTabs}>Debug</p>}
                    </div>
                    <div className=" colonna4-l fl-l w-100 w-50-ns w-70-l mt4 pb2 pl2 pr2 pl4-l colonna90vh sezioneConScroll bl-ns bordoColAlt">
                        {
                            tab === "CatWeb" && <div>
                                <InputTendinaCategoria
                                    objOpzioni={datiCategoriaPred}
                                    datoValue={prodottoTemp.categoriaPredefinita}
                                    inputLabel="Categoria predefinita"
                                    datoName="categoriaPredefinita"
                                    datoId={"catpref"}
                                    datoOnChange={handleChangeDatoUlteriore}
                                    datoClass={inputClasses}
                                />

                                <CategorieWebSub
                                    onChange={handleChangeCategorieWeb}
                                    data={datiCategorieWeb}
                                    categorie={prodottoTemp.categorieWebAssociate}
                                />

                            </div>
                        }
                    </div>

                </div>
            </div>
        </div>
    )
}

export default AggiuntaMassivaCategorieDB;
